import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  Col,
  Container,
  NavItem,
  Row,
  TabContent,
  TabPane
} from "reactstrap";

import classNames from "classnames";
import "./style.scss";

//Import Breadcrumb
import { getOneEntity } from "http/fundLync/entityAndAddress.helper";
import CreditVerification from "./CreditVerification";
import BSADocuments from "./bsaDocuments";
import FinancialDocuments from "./financialDocument";
import GSTDocuments from "./gstDocuments";
import ITRDocuments from "./itrDocuments";
import AdditionalDocuments from "./additionalDocuments";

const AddEntityDocuments = (props) => {
  //meta title
  document.title = "Audited Financials | FundLync";
  const urlParams = new URLSearchParams(window.location.search);
  const encodedId = urlParams.get("tab");
  const encodedEntityId = urlParams.get("id");
  const decodedId = atob(encodedId);
  const entityId = atob(encodedEntityId);

  const [activeTabVartical, setoggleTabVertical] = useState(1);
  const [passedStepsVertical, setPassedStepsVertical] = useState([1]);
  const [entityDetail, setEntityDetail] = useState([]);
  const [constituition, setConstituition] = useState();

  useEffect(() => {
    toggleTabVertical(+decodedId);
  }, [decodedId]);

  useEffect(() => {
    getOneEntity({ entityId })
      .then((response) => {
        if (response) {
          setEntityDetail(response.data);
          if(response.data?.length>0)
            {
              const entity = response.data[0] 
              setConstituition(entity.entityConstitution)
            }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);


  function toggleTabVertical(tab) {
    if (activeTabVartical !== tab) {
      const modifiedSteps = [...passedStepsVertical, tab];
      if (
        constituition == "Public Limited Company" ||
        constituition == "Private Limited Company"
      ) {
        if (tab >= 1 && tab <= 1) {
          setoggleTabVertical(tab);
          setPassedStepsVertical(modifiedSteps);
        }
      } else {
        if (tab >= 1 && tab <= 6) {
          setoggleTabVertical(tab);
          setPassedStepsVertical(modifiedSteps);
        }
      }
    }
  }

  return (
      <div className="page-content">
        <Container fluid>
          {/* <Breadcrumbs title="" breadcrumbItem={entityDetail.entityName} /> */}
          <Col sm={4}>
            <h4>{entityDetail[0]?.entityName}</h4>
          </Col>
          <div className="vertical-scroll">
            <Row>
              <Col lg="12">
                {/* <Card>
                  <CardBody> */}
                <div className="wizard clearfix">
                  <div className="steps clearfix">
                    <ul>
                      {constituition == "Proprietorship" ||
                      constituition == "Limited Liability Partnership" ||
                      constituition == "Partnership" ? (
                        <NavItem
                          className={classNames({
                            current: activeTabVartical === 1,
                          })}
                        >
                          <NavLink
                            className={
                              (classNames({
                                active: activeTabVartical === 1,
                              }),
                              "done")
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              toggleTabVertical(1);
                            }}
                            disabled={!(passedStepsVertical || []).includes(1)}
                          >
                            <div className="d-flex">
                              <span className="number">1</span>
                              <div className="formWizardText">
                                {" "}
                                Credit Verification{" "}
                              </div>
                            </div>
                          </NavLink>
                        </NavItem>
                      ) : null}

                      {constituition == "Proprietorship" ||
                      constituition == "Limited Liability Partnership" ||
                      constituition == "Partnership" ? (
                        <NavItem
                          className={classNames({
                            current: activeTabVartical === 2,
                          })}
                        >
                          <NavLink
                            className={
                              (classNames({
                                active: activeTabVartical === 2,
                              }),
                              "done")
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              toggleTabVertical(2);
                            }}
                            disabled={!(passedStepsVertical || []).includes(2)}
                          >
                            <div className="d-flex">
                              <span className="number">2</span>
                              <div className="formWizardText">
                                {" "}
                                ITR documents{" "}
                              </div>
                            </div>
                          </NavLink>
                        </NavItem>
                      ) : null}
                      {constituition == "Proprietorship" ||
                      constituition == "Limited Liability Partnership" ||
                      constituition == "Partnership" ? (
                        <NavItem
                          className={classNames({
                            current: activeTabVartical === 3,
                          })}
                        >
                          <NavLink
                            className={
                              (classNames({
                                active: activeTabVartical === 3,
                              }),
                              "done")
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              toggleTabVertical(3);
                            }}
                            disabled={!(passedStepsVertical || []).includes(3)}
                          >
                            <div className="d-flex">
                              <span className="number">3</span>
                              <div className="formWizardText">
                                {" "}
                                GST documents{" "}
                              </div>
                            </div>
                          </NavLink>
                        </NavItem>
                      ) : null}
                      {constituition == "Proprietorship" ||
                      constituition == "Limited Liability Partnership" ||
                      constituition == "Partnership" ? (
                        <NavItem
                          className={classNames({
                            current: activeTabVartical === 4,
                          })}
                        >
                          <NavLink
                            className={
                              (classNames({
                                active: activeTabVartical === 4,
                              }),
                              "done")
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              toggleTabVertical(4);
                            }}
                            disabled={!(passedStepsVertical || []).includes(4)}
                          >
                            <div className="d-flex">
                              <span className="number">4</span>
                              <div className="formWizardText">
                                {" "}
                                Bank Statements{" "}
                              </div>
                            </div>
                          </NavLink>
                        </NavItem>
                      ) : null}

                      {constituition == "Public Limited Company" || constituition == "Private Limited Company" ? (
                        <NavItem
                          className={classNames({
                            current: activeTabVartical === 1,
                          })}
                        >
                          <NavLink
                            className={
                              (classNames({
                                active: activeTabVartical === 1,
                              }),
                              "done")
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              toggleTabVertical(1);
                            }}
                            disabled={!(passedStepsVertical || []).includes(1)}
                          >
                            <div className="d-flex align-items-center">
                              <span className="number">1</span>
                              <div className="formWizardText">
                                Audited Financials
                              </div>
                            </div>
                          </NavLink>
                        </NavItem>
                      ) : (
                        <NavItem
                          className={classNames({
                            current: activeTabVartical === 5,
                          })}
                        >
                          <NavLink
                            className={
                              (classNames({
                                active: activeTabVartical === 5,
                              }),
                              "done")
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              toggleTabVertical(5);
                            }}
                            disabled={!(passedStepsVertical || []).includes(5)}
                          >
                            <div className="d-flex align-items-center">
                              <span className="number">5</span>
                              <div className="formWizardText">
                                Audited Financials
                              </div>
                            </div>
                          </NavLink>
                        </NavItem>
                      )}
                      {constituition == "Public Limited Company" || constituition == "Private Limited Company" ? (
                        <NavItem
                        className={classNames({
                          current: activeTabVartical === 2,
                        })}
                      >
                        <NavLink
                          className={
                            (classNames({
                              active: activeTabVartical === 2,
                            }),
                            "done")
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            toggleTabVertical(6);
                          }}
                          disabled={!(passedStepsVertical || []).includes(6)}
                        >
                          <div className="d-flex">
                            <span className="number">2</span>
                            <div className="formWizardText">
                              {" "}
                              Additional Documents{" "}
                            </div>
                          </div>
                        </NavLink>
                      </NavItem>
                      ) : (
                        <NavItem
                          className={classNames({
                            current: activeTabVartical === 6,
                          })}
                        >
                          <NavLink
                            className={
                              (classNames({
                                active: activeTabVartical === 6,
                              }),
                              "done")
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              toggleTabVertical(6);
                            }}
                            disabled={!(passedStepsVertical || []).includes(6)}
                          >
                            <div className="d-flex">
                              <span className="number">6</span>
                              <div className="formWizardText">
                                {" "}
                                Additional Documents{" "}
                              </div>
                            </div>
                          </NavLink>
                        </NavItem>
                      )}
                      {/* {constituition == "Proprietorship" ||
                      constituition == "Limited Liability Partnership" ||
                      constituition == "Partnership" ? (
                        <NavItem
                          className={classNames({
                            current: activeTabVartical === 6,
                          })}
                        >
                          <NavLink
                            className={
                              (classNames({
                                active: activeTabVartical === 6,
                              }),
                              "done")
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              toggleTabVertical(6);
                            }}
                            disabled={!(passedStepsVertical || []).includes(6)}
                          >
                            <div className="d-flex">
                              <span className="number">6</span>
                              <div className="formWizardText">
                                {" "}
                                Additional Documents{" "}
                              </div>
                            </div>
                          </NavLink>
                        </NavItem>
                      ) : null} */}
                    </ul>
                  </div>
                  <div className="content clearfix">
                    <TabContent activeTab={activeTabVartical} className="body">
                      {constituition == "Proprietorship" ||
                      constituition == "Limited Liability Partnership" ||
                      constituition == "Partnership" ? (
                        <TabPane tabId={1}>
                          {activeTabVartical == 1 && <CreditVerification />}
                        </TabPane>
                      ) : null}
                      {constituition == "Proprietorship" ||
                      constituition == "Limited Liability Partnership" ||
                      constituition == "Partnership" ? (
                        <TabPane tabId={2}>
                          {activeTabVartical == 2 && <ITRDocuments />}
                        </TabPane>
                      ) : null}
                      {constituition == "Proprietorship" ||
                      constituition == "Limited Liability Partnership" ||
                      constituition == "Partnership" ? (
                        <TabPane tabId={3}>
                          {activeTabVartical == 3 && <GSTDocuments />}
                        </TabPane>
                      ) : null}
                      {constituition == "Proprietorship" ||
                      constituition == "Limited Liability Partnership" ||
                      constituition == "Partnership" ? (
                        <TabPane tabId={4}>
                          {activeTabVartical == 4 && <BSADocuments />}
                        </TabPane>
                      ) : null}

                      {constituition == "Public Limited Company" ||
                      constituition == "Private Limited Company" ? (
                        <TabPane tabId={1}>
                          <FinancialDocuments />
                        </TabPane>
                      ) : (
                        <TabPane tabId={5}>
                          {activeTabVartical == 5 && <FinancialDocuments />}
                        </TabPane>
                      )}

                      {constituition == "Public Limited Company" ||
                        constituition == "Private Limited Company" ? (
                          <TabPane tabId={2}>
                            <AdditionalDocuments />
                          </TabPane>
                        ) : (
                          <TabPane tabId={6}>
                          {activeTabVartical == 6 && <AdditionalDocuments />}
                        </TabPane>
                      )}
                      {constituition == "Proprietorship" ||
                      constituition == "Limited Liability Partnership" ||
                      constituition == "Partnership" ? (
                        <TabPane tabId={6}>
                          {activeTabVartical == 6 && <AdditionalDocuments />}
                        </TabPane>
                      ) : null}
                    </TabContent>
                  </div>
                  <div className="actions clearfix">
                    <ul>
                      <li
                        className={
                          activeTabVartical === 1
                            ? "previous disabled"
                            : "previous"
                        }
                      >
                        <Link
                          to="#"
                          onClick={() => {
                            toggleTabVertical(activeTabVartical - 1);
                          }}
                        >
                          Previous
                        </Link>
                      </li>
                      {constituition == "Public Limited Company" ||
                      constituition == "Private Limited Company" ? (
                        <li
                          className={
                            activeTabVartical === 1 ? "next disabled" : "next"
                          }
                        >
                          <Link
                            to="#"
                            onClick={() => {
                              toggleTabVertical(activeTabVartical + 1);
                            }}
                          >
                            Next
                          </Link>
                        </li>
                      ) : (
                        <li
                          className={
                            activeTabVartical === 6 ? "next disabled" : "next"
                          }
                        >
                          <Link
                            to="#"
                            onClick={() => {
                              toggleTabVertical(activeTabVartical + 1);
                            }}
                          >
                            Next
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
  );
};

export default AddEntityDocuments;
